<template>
  <section class="project-step mgt-3 mgb-3">
    <div
      class="modal fade custom-modal"
      id="addPostModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addPostModalLabel"
      aria-hidden="true"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div
          type="button"
          class="dismiss-modal-btn"
          data-dismiss="modal"
          aria-label="Close"
        >
          <i aria-hidden="true" class="fad fa-times-circle"></i>
        </div>
        <div class="section-loading-screen" v-if="showLoading">
          <div class="section-loading-bubbles">
            <span class="d1"></span>
            <span class="d2"></span>
            <span class="d3"></span>
            <span class="d4"></span>
          </div>
        </div>
        <div class="modal-content custom-modal-content">
          <div class="modal-header custom-modal-header">
            <i class="fa fa-info"></i>
            <h5 class="modal-title" id="addPostModalLabel" v-if="postId">Editeaza postarea</h5>
            <h5 class="modal-title" id="addPostModalLabel" v-else>Adauga postare</h5>
          </div>
          <div class="modal-body">
            <form id="form-posts" class="step-form general-form">
              <div class="row project-step-row">
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4"
                >
                  <div class="description-wrapper">
                    <div class="secondary-heading">
                      <div class="secondary-heading-icon">
                        <i class="fad fa-align-left"></i>
                      </div>
                      <span> * Descriere </span>
                    </div>
                      <div class="editor-wrapper">
                          <vue-editor
                              v-model="postDescription"
                              :editorOptions="{
                                    modules: {
                                        toolbar: [
                                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                            ['bold', 'italic', 'underline', 'strike'],
                                            [{ 'align': ''}, {'align': 'center'}, { 'align': 'right'}, {'align': 'justify'}],
                                            [{ 'list': 'bullet' }, { 'list': 'ordered'}, { 'indent': '-1'}, { 'indent': '+1' }],
                                            ['clean'],
                                            [{ 'color': [] }, { 'background': [] }],
                                            ['link', 'image', 'video', 'emoji'],
                                        ],
                                        'emoji-toolbar': true,
                                        // 'emoji-textarea': true,
                                        'emoji-shortname': true,
                                    }
                                }"/>
                          <p class="custom-input-error" id="postDescription_error"></p>
                      </div>
                  </div>
                </div>
              </div>

              <div class="row project-step-row">
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4"
                >
                  <div class="secondary-heading">
                    <div class="secondary-heading-icon">
                      <i class="fad fa-images"></i>
                    </div>
                    <span> Imagini </span>
                  </div>
                  <div class="project-images-wrapper">
                    <p
                      class="custom-input-error"
                      id="ungroupedImages_error"
                    ></p>
                    <p
                      class="custom-input-error"
                      :id="`ungroupedImages-${index}_error`"
                      v-for="(img, index) in ungroupedImages"
                      :key="`ung-${index}`"
                    ></p>
                    <div class="row">
                      <div class="col-12">
                        <div class="images-group-uploader">
                          <input
                            type="file"
                            id="groupImages"
                            multiple
                            @change="onMultipleFileChange"
                          />
                          <label
                            for="groupImages"
                            class="general-btn positive-btn"
                          >
                            <span> Incarca imagini </span>
                            <i class="fad fa-upload"></i>
                          </label>
                        </div>
                        <draggable
                          v-if="ungroupedImages"
                          class="images-group card-columns"
                          :list="ungroupedImages"
                          :forceFallback="true"
                          group="picsGroup"
                        >
                          <div
                            v-for="(image, index) in ungroupedImages"
                            :key="index"
                            class="group-uploaded-img card"
                          >
                            <img :src="image.base64" @click="triggerImg" />
                            <div
                              class="clear-post-img"
                              @click="removeUngroupImage(index, image)"
                            >
                              <i class="fad fa-trash-alt"></i>
                            </div>
                          </div>
                        </draggable>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row project-step-row">
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4"
                >
                  <div class="secondary-heading">
                    <div class="secondary-heading-icon">
                      <i class="fad fa-video"></i>
                    </div>
                    <span> Linkuri Video (doar Youtube) </span>
                  </div>
                  <div class="video-links-wrapper">
                    <p class="custom-input-error" id="video_error"></p>
                    <div class="row">
                      <div
                        class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mb-4"
                        v-for="(videoRow, index) in videoRows"
                        :key="index"
                      >
                        <div class="input-container">
                          <div class="input-group mg-b">
                            <input
                              v-model="videoRow.url"
                              placeholder="Link Video"
                              type="text"
                              name="video[]"
                            />
                            <div class="input-icon">
                              <i class="fad fa-video"></i>
                            </div>
                            <label class="custom-label sr-only"> Link Video </label>
                          </div>
                          <span
                            class="floating-remove-el"
                            @click="removeVideoElement(index)"
                          >
                            <i class="fad fa-times-circle"></i>
                          </span>
                          <p
                            class="custom-input-error"
                            :id="`video-${index}_error`"
                          ></p>
                        </div>
                        <linkPrevue :url="videoRow.url">
                          <template slot-scope="props">
                            <div class="prevue-card">
                              <a
                                v-bind:href="props.url"
                                target="_blank"
                                class="general-btn positive-btn prevue-viewmore-btn"
                              >
                                <span> Vezi link </span>
                                <i class="fad fa-eye"></i>
                              </a>
                            </div>
                          </template>
                        </linkPrevue>
                      </div>
                      <div class="col-12">
                        <button
                          @click.prevent="addVideoRow()"
                          class="general-btn positive-btn"
                        >
                          <i class="fad fa-video-plus"></i>
                          <span> Adauga link </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer custom-modal-footer">
            <button
              type="button"
              class="general-btn negative-btn"
              data-dismiss="modal"
            >
              <i class="fad fa-times-circle"></i>
              <span> Inchide </span>
            </button>
            <button
              type="button"
              @click="save()"
              class="general-btn positive-btn"
            >
              <i class="fad fa-save"></i>
              <span> Salveaza </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="fullscreen-preview"
      class="fullscreen-img"
      :class="{ 'fullscreen-img-active': fullScreen }"
    >
      <div class="fullscreen-container" v-if="fullScreenScr">
        <img :src="fullScreenScr" alt="" />
      </div>
      <div class="close-element" @click="fullScreen = !fullScreen">
        <i class="fad fa-times-circle"></i>
      </div>
    </div>
  </section>
</template>

<script>
import draggable from 'vuedraggable'
import linkPrevue from 'link-prevue'
import $ from 'jquery'
import { VueEditor, Quill } from "vue2-editor";
import Emoji from "quill-emoji/dist/quill-emoji";

Quill.register("modules/emoji", Emoji);

export default {
  name: "AddNewsfeedPost",
  props: ["projectId", "newsfeedPost", "newsfeedPostImages"],
  components: {
    draggable,
    linkPrevue,
    VueEditor
  },
  data() {
    return {
      showLoading: false,
      postId: 0,
      postDescription: "",
      ungroupedImages: [],
      videoRows: [],
      files: [],
      fullScreenScr: "",
      fullScreen: false,
      deleteImages: [],
      editor: null,
    };
  },
  mounted() {
    let vm = this;
    $("#form-posts").submit(function (e) {
      e.preventDefault();
      vm.save();
    });
    vm.videoRows.push({ url: "" });
    $('[data-toggle="tooltip"]').tooltip();

    // on close modal
    $("#addPostModal").on("hidden.bs.modal", function () {
      vm.postDescription = "";
      vm.ungroupedImages = [];
      vm.videoRows = [];
      vm.postId = 0;
    });

    // on open modal
    this.$eventBus.$on(
      "OPEN_EDIT_NEWSFEED_POST_MODAL",
      async function (payLoad) {
        vm.postId = payLoad.newsfeedPost.id;
        vm.postDescription = payLoad.newsfeedPost.news;
        vm.ungroupedImages = payLoad.newsfeedPostImages;

        const videos = payLoad.newsfeedPost.links;
        vm.videoRows = [];
        videos.forEach(function (video) {
          vm.videoRows.push({ url: video });
        });

        $("#addPostModal").modal("show");
      }
    );
  },
  methods: {
    addVideoRow: function () {
      this.videoRows.push({
        url: "",
      });
    },
    removeVideoElement: function (index) {
      this.videoRows.splice(index, 1);
    },
    triggerImg: function (img) {
      this.fullScreenScr = img.srcElement.src;
      this.fullScreen = !this.fullScreen;
    },

    onMultipleFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files);
    },
    createImage(files) {
      let vm = this;
      for (let index = 0; index < files.length; index++) {
        let fileType = files[index].type;
        if (fileType === "image/jpeg" || fileType === "image/png") {
          let reader = new FileReader();
          reader.onload = function (event) {
            const groupImageUrl = { base64: event.target.result };
            vm.ungroupedImages.push(groupImageUrl);
          };
          reader.readAsDataURL(files[index]);
        } else {
          window.Swal.fire({
            html: "Sunt permise doar imagini de tip jpg sau png",
            icon: "warning",
          });
        }
      }
    },

    removeUngroupImage(index, image) {
      if (image.id && image.id > 0) {
        this.deleteImages.push(image.id)
      }
      this.ungroupedImages.splice(index, 1);
    },

    save() {
      window.resetErrors();

      let vm = this;
      vm.showLoading = true;
      let myForm = document.getElementById("form-posts");
      let formData = new FormData(myForm);

      // send only new images
      let sendImages = [];
      this.ungroupedImages.forEach(function(image) {
        let imageClone = JSON.parse(JSON.stringify(image));
        if (imageClone.id && imageClone.id > 0) {
          delete imageClone.base64;
        }
        sendImages.push(imageClone);
      })
      formData.append('ungroupedImages', JSON.stringify(sendImages));
      formData.append('deleteImages', JSON.stringify(this.deleteImages));
      if(!this.videoRows.length) {
        formData.append('video[]', '');
      }
        if(this.postDescription != null) {
            formData.append('postDescription', this.postDescription);
        }
      console.log('formData', formData);

      if(vm.postId) {
        window.axios
            .post(`/developer/project/${vm.projectId}/edit-news/${vm.postId}`, formData)
            .then(function () {
              vm.showLoading = false;
              let message = "Postarea ta a fost editata cu succes";
              window.Swal.fire({
                html: message,
                icon: "success",
                timer: 2000,
                showCancelButton: false,
                showConfirmButton: false
              }).then(() => {
                window.location.href = `/developer/project/${vm.projectId}?tab=details`;
              });
            })
            .catch(function (err) {
              vm.showLoading = false;
              vm.buttonDisable = false;
              window.showError(err);
            });
      } else {
        window.axios
            .post(`/developer/project/${this.projectId}`, formData)
            .then(function (response) {
              vm.showLoading = false;
              let message =
                  "Postarea ta a fost trimisa.<br />" +
                  " Mai aveti " +
                  response.data.data.remaining +
                  " postari pe aceasta luna";
              window.Swal.fire({
                html: message,
                icon: "success",
                timer: 2000,
                showCancelButton: false,
                showConfirmButton: false
              }).then(() => {
                window.location.href = `/developer/project/${vm.projectId}?tab=details`;
              });
            })
            .catch(function (err) {
              vm.showLoading = false;
              vm.buttonDisable = false;
              window.showError(err);
            });
      }
    },
  },
};
</script>
